import Button from 'Components/Button'
import DisplayPrice from 'Components/Price/DisplayPrice'
import ProductQuantityInput from 'Components/ProductQuantityInput'

import { SVGIconBasket, SVGTrashSmall, SVGIconWarningLabel, SVGProdGift } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import btnCss from 'Components/Button/Button.scss'
import cl from './CartTable.scss'
import { Component } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { ViewType } from 'Components/ProductQuantityInput/ProductQuantityInput'
import { CartFragment, ProductListData, CartFragment_cart_products, getCheckoutInfo_shippingMethods } from 'Utils/api/gql/types'
import { cartRequestProductUpdate } from 'Utils/redux/actions'
import { weightFormatter } from 'Utils/helpers/formatters'
import { getImageForSizeOrPlaceholder } from 'Utils/helpers/productAttributeHelper'
import CartHelper from 'Utils/helpers/cartHelper';
import ProductLink from 'Components/ProductLink';
import CheckoutHelper from 'Utils/helpers/checkoutHelper';
import GiftMessage from '../GiftMessage';

type StateProps = {
  cart: CartFragment | null
  orderData: Redux.IOrderData
  shippingMethods: getCheckoutInfo_shippingMethods[]
} & DispatchProp

type PropType = {
  readOnly?: boolean
  selectedMethod?: string | null
  availableShippingMethods?: getCheckoutInfo_shippingMethods[]
  cartProducts?: CartFragment_cart_products[]
}

class CartTable extends Component<PropType & StateProps> {
  handleRemoveFromCart = (product: ProductListData) => () => {
    this.props.dispatch(cartRequestProductUpdate({ product, newQuantity: 0, quantityType: 'default' }))
  }

  handleQtyChange = (product: ProductListData) => (value: number, qtyType: Redux.QtyType) => {
    this.props.dispatch(cartRequestProductUpdate({ product, newQuantity: value, quantityType: qtyType }))
  }
  
  renderRow(cartItem: CartFragment_cart_products | Webshop.EmptiesCartProduct, renderWeight: boolean, problemProductIds: Array<string>) {
    const product = cartItem.__typename === 'CartProduct'
      ? cartItem.product
      : cartItem.empties

    const itemHasProblem = problemProductIds.includes(product.id)

    const qtyInputNotLarge = cartItem.__typename === 'CartProduct'
      ? <ProductQuantityInput
          cartItem={cartItem}
          view={ViewType.Cart}
          onChange={this.handleQtyChange(cartItem.product)}
        />
      : <div className={cn(cg.textCenter, cl.empties)}>{cartItem.piece} {cartItem.empties.default_quantity_name}</div>

    const qtyInputLarge = cartItem.__typename === 'CartProduct'
      ? <ProductQuantityInput
          cartItem={cartItem}
          view={ViewType.CartTable}
          onChange={this.handleQtyChange(cartItem.product)}
        />
      : qtyInputNotLarge
      
    const readOnlyQty = cartItem.__typename === 'CartProduct'
      ? <div className={cn(cg.textCenter, cl.empties)}>{cartItem.piece} {cartItem.product.default_quantity_name}</div>
      : <div className={cn(cg.textCenter, cl.empties)}>{cartItem.piece} {cartItem.empties.default_quantity_name}</div>

    const image = (
      <div className={cn(cg.cell, cg.shrink, cl.cartTable__imageWrapper)}>
        <img src={getImageForSizeOrPlaceholder(product, 0, 'thumbnail')} alt="" />
      </div>
    )

    const productImage = cartItem.__typename === 'CartProduct'
      ? (
        <ProductLink product={cartItem.product}>
          {image}
        </ProductLink>
      ) : image

    const name = (
      <div className={cl.cartTable__dataName}>
        {product.name}
      </div>
    )

    const productName = cartItem.__typename === 'CartProduct'
      ? (
        <ProductLink product={cartItem.product}>
          {name}
        </ProductLink>
      ) : name
      
    return (
      /* tr */
      <div key={product.id} className={cn(cg.gridX, cl.valigner, cl.cartTable__tr, itemHasProblem ? cl.cartTable__trHasProblem : {})}>
        <div className={cn(cg.cell, cg.auto, cl.cartTable__td)}>
          <div className={cn(cg.gridX, cl.valigner)}>
            {productImage}
            <div className={cn(cg.cell, cg.auto)}>
              <div  className={cn(cg.gridX, cl.valigner)}>
                <div className={cn(cg.cell, cg.small12, cg.largeAuto )}>
                  {productName}
                  
                  {itemHasProblem ? (
                    <div className={cn(cg.gridX, cg.alignMiddle, cl.itemHasProblem)}>
                      <div className={cn(cg.cell, cl.itemHasProblemIcon)}>
                        <SVGIconWarningLabel />
                      </div>
                      <div className={cn(cg.cell, cl.itemHasProblemText)}>
                        A kiválasztott szállítási móddal nem rendelhető. 
                      </div>
                    </div>
                  ):('')}

                  {cartItem.__typename === 'CartProduct' && <GiftMessage cartProduct={cartItem} />}

                </div>
                <div className={cn(cg.cell, cl.quantityHolder, cl.cartTable__quantityWrapper)}>
                  <div className={cg.hideForLarge}>
                    {!this.props.readOnly ? qtyInputNotLarge : readOnlyQty}
                  </div>
                  <div className={cg.showForLarge}>
                    {!this.props.readOnly ? qtyInputLarge : readOnlyQty}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cn(cg.cell, cl.priceHolder, cl.valigner, cl.cartTable__td)}>
          <div className={cn(cg.gridX, cl.mobileOrder, cl.valigner, cl.fullWidth)}>
          { cartItem.__typename === 'CartProduct' && !this.props.readOnly &&
            <div className={cn(cg.cell, cl.deleteHolder, cl.cartTable__buttonWrapper)}>
              <Button
                className={cn(btnCss.grayIcon, btnCss.flat, cl.deleteButton)}
                renderIcon={{
                  ariaLabel: 'Törlés a kosárból',
                  Icon: <SVGTrashSmall width="32" height="32" />
                }}
                titleName='Törlés a kosárból'
                onClick={this.handleRemoveFromCart(cartItem.product)}
              />
            </div>
          }
            <div className={cn(cg.cell, cg.small12, cg.mediumAuto, cg.alignSelfBottom, cg.textRight, cl.cartTable__priceWrapper)}>

              {renderWeight ? (
                <strong>{weightFormatter(product.weight * cartItem.piece)}</strong>
              ):(
                <DisplayPrice
                  product={product}
                  qty={cartItem.piece}
                />
              )}

            </div>
          </div>
        </div>
      </div>
    )
  }

  renderEmptyRow = () => {
    return (
      <div className={cn(cg.gridX, cg.alignMiddle, cg.alignCenter)}>
        <div className={cn(cg.cell, cg.shrink)} style={{marginTop: 30, marginBottom: 30}}>
          <div className={cn(cg.gridX, cg.alignMiddle, cg.gridMarginX ,cg.gridPaddngX)}>
            <div className={cn(cg.cell, cg.shrink, cl.cartTable__imageWrapperIsEmpty)} aria-hidden={true}>
              <SVGIconBasket width={80} height={80} />
            </div>
            <div className={cn(cg.cell, cg.alignMiddle, cg.shrink)}>
              <div className={cl.cartTable__dataName}>
                A kosarad jelenleg üres.
                <br />
                Adj hozzá termékeket!
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { cart, orderData, shippingMethods } = this.props

    const isEmpty = !cart || cart.cart_products.length === 0
    const reduxProducts = [...(cart && cart.cart_products || [])].reverse()
    const cartProducts = this.props.cartProducts || reduxProducts
    const empties = CartHelper.aggregateEmptiesFromCartProducts(cartProducts)

    const selectedMethod = this.props.selectedMethod ? this.props.selectedMethod! : orderData.selected_method
    const availableMethods = this.props.availableShippingMethods ? this.props.availableShippingMethods! : shippingMethods
    const method = CheckoutHelper.getMethod(selectedMethod as Redux.ShippingMethodCode, availableMethods)

    const renderWeight = method && CheckoutHelper.methodHasWeightProblem(method) || false
    const problemProductIds = method && CheckoutHelper.getProhibitedItems(method) || []

    return (
      /* table */
      <div className={cl.cartTable}>
        {/* tbody */}
        <div className={cl.cartTable__tbody}>
          {isEmpty
            ? this.renderEmptyRow()
            : <>
              {cartProducts.map(item => this.renderRow(item, renderWeight, problemProductIds))}
              {empties.map(item => this.renderRow(item, renderWeight, problemProductIds))}
              </>
          }
        </div>
      </div>
    )
  }
}


function mapToStateProps({ cart, orderData, checkoutInfo: { shippingMethods } }: Redux.IReduxState) {
  return { cart, orderData, shippingMethods }
}

export default connect(mapToStateProps)(CartTable)
